<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fas fa-exclamation-circle me-2"></i>
      Détails de la plainte #{{ complaint.id }}
    </h5>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-4 mb-4">
        <div class="card h-100">
          <div class="card-header">
            <h6 class="mb-0">Informations de l'auteur</h6>
          </div>
          <div class="card-body">
            <div class="d-flex align-items-center mb-3" *ngIf="complaint.user">
              <img *ngIf="isValidImage(complaint.user.profile_picture) && !complaint.user._hideImage; else userInit"
                [src]="complaint.user.profile_picture" (error)="onImageError(complaint.user)"
                class="rounded-circle me-3" style="width: 64px; height: 64px; object-fit: cover;"
                [alt]="complaint.user.name">
              <ng-template #userInit>
                <div class="avatar-initial me-3"
                  [style.background-color]="getAvatarColor(getDisplayName(complaint.user))">
                  {{ getAvatarInitial(getDisplayName(complaint.user)) }}
                </div>
              </ng-template>
              <div>
                <h6 class="mb-1">{{ complaint.user.prenom }} {{ complaint.user.nom }}</h6>
                <p class="text-muted mb-0">{{ complaint.user.email }}</p>
              </div>
            </div>
            <div class="row" *ngIf="complaint.user">
              <div class="col-12 mb-2">
                <p class="mb-0"><strong>Téléphone:</strong></p>
                <p class="text-muted mb-0">{{ complaint.user.telephone || '-' }}</p>
              </div>
              <div class="col-12">
                <p class="mb-0"><strong>Rang:</strong></p>
                <p class="text-muted mb-0">{{ complaint.user.rang }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 mb-4">
        <div class="card h-100">
          <div class="card-header">
            <h6 class="mb-0">Informations de la cible</h6>
          </div>
          <div class="card-body">
            <div class="d-flex align-items-center mb-3" *ngIf="complaint.against">
              <img
                *ngIf="isValidImage(complaint.against.profile_picture) && !complaint.against._hideImage; else againstInit"
                [src]="complaint.against.profile_picture" (error)="onImageError(complaint.against)"
                class="rounded-circle me-3" style="width: 64px; height: 64px; object-fit: cover;"
                [alt]="complaint.against.name">
              <ng-template #againstInit>
                <div class="avatar-initial me-3"
                  [style.background-color]="getAvatarColor(getDisplayName(complaint.against))">
                  {{ getAvatarInitial(getDisplayName(complaint.against)) }}
                </div>
              </ng-template>
              <div>
                <h6 class="mb-1">{{ complaint.against.scene_name || (complaint.against.prenom + ' ' +
                  complaint.against.nom) }}</h6>
                <p class="text-muted mb-0">{{ complaint.against.email }}</p>
              </div>
            </div>
            <div class="row" *ngIf="complaint.against">
              <div class="col-12 mb-2">
                <p class="mb-0"><strong>Téléphone:</strong></p>
                <p class="text-muted mb-0">{{ complaint.against.telephone || '-' }}</p>
              </div>
              <div class="col-12">
                <p class="mb-0"><strong>Rang:</strong></p>
                <p class="text-muted mb-0">{{ complaint.against.rang }}</p>
              </div>
            </div>
            <div *ngIf="!complaint.against" class="text-center py-4">
              <i class="fas fa-cog fa-3x text-muted mb-2"></i>
              <p class="text-muted">Plateforme Yokastar</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 mb-4">
        <div class="card h-100">
          <div class="card-header">
            <h6 class="mb-0">Détails de la plainte</h6>
          </div>
          <div class="card-body">
            <div class="mb-3" *ngIf="complaint.reference">
              <p class="mb-0"><strong>Référence:</strong></p>
              <p class="text-muted mb-0">{{ complaint.reference }}</p>
            </div>
            <div class="mb-3">
              <p class="mb-0"><strong>Type:</strong></p>
              <span class="badge" [ngClass]="getTypeBadgeClass(complaint.type)">
                {{ getTypeLabel(complaint.type) }}
              </span>
            </div>
            <div class="mb-3" *ngIf="complaint.payment_reference">
              <p class="mb-0"><strong>Référence du paiement:</strong></p>
              <p class="text-muted mb-0">{{ complaint.payment_reference }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12 w-100">
        <div class="card">
          <div class="card-header">
            <h6 class="mb-0">Contenu de la plainte</h6>
          </div>
          <div class="card-body">
            <div class="mb-3">
              <p class="mb-1"><strong>Description détaillée:</strong></p>
              <div class="p-3 bg-light rounded border">
                {{ complaint.description || 'Aucune description fournie.' }}
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <p class="mb-1"><strong>Date de soumission:</strong></p>
                <p class="text-muted"><i class="far fa-calendar-alt me-2"></i>{{ formatDate(complaint.created_at) }}
                </p>
              </div>
              <div class="col-md-6">
                <p class="mb-1"><strong>Dernière modification:</strong></p>
                <p class="text-muted"><i class="far fa-clock me-2"></i>{{ formatDate(complaint.updated_at) }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Niveau de traitement -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h6 class="mb-0">Niveau de traitement</h6>
          </div>
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between">
              <div class="treatment-levels flex-grow-1">
                <div class="d-flex align-items-center w-100">
                  <div class="level-item" [class.active]="getTreatmentLevel(complaint.status) >= 1"
                    [style.background-color]="getTreatmentLevel(complaint.status) >= 1 ? getTreatmentLevelColor(1) : '#e9ecef'">
                    <i class="fas fa-clock"></i>
                    <span>Validation Initiale</span>
                  </div>
                  <div class="level-connector" [class.active]="getTreatmentLevel(complaint.status) >= 2"></div>
                  <div class="level-item" [class.active]="getTreatmentLevel(complaint.status) >= 2"
                    [style.background-color]="getTreatmentLevel(complaint.status) >= 2 ? getTreatmentLevelColor(2) : '#e9ecef'">
                    <i class="fas fa-check"></i>
                    <span>Validé</span>
                  </div>
                  <div class="level-connector" [class.active]="getTreatmentLevel(complaint.status) >= 3"></div>
                  <div class="level-item" [class.active]="getTreatmentLevel(complaint.status) >= 3"
                    [style.background-color]="getTreatmentLevel(complaint.status) >= 3 ? getTreatmentLevelColor(3) : '#e9ecef'">
                    <i class="fas fa-search"></i>
                    <span>En analyse</span>
                  </div>
                  <div class="level-connector" [class.active]="getTreatmentLevel(complaint.status) >= 4"></div>
                  <div class="level-item" [class.active]="getTreatmentLevel(complaint.status) >= 4"
                    [style.background-color]="getTreatmentLevel(complaint.status) >= 4 ? getTreatmentLevelColor(4) : '#e9ecef'">
                    <i class="fas fa-flag-checkered"></i>
                    <span>Terminé</span>
                  </div>
                </div>
              </div>
              <!-- <div class="ms-3">
                <span class="badge status-badge" 
                      [ngClass]="getStatusDisplay(complaint.status).class">
                  {{ getStatusDisplay(complaint.status).text }}
                </span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Chronologie du traitement -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h6 class="mb-0">Chronologie du traitement</h6>
          </div>
          <div class="card-body">
            <div class="timeline">
              <div class="timeline-item" *ngFor="let history of statusHistory; let i = index">
                <div class="timeline-marker">
                  <i class="fas"
                    [class.fa-check-circle]="history.new_status === 'validated' || history.new_status === 'validée' || history.new_status === 'resolved' || history.new_status === 'résolue'"
                    [class.fa-times-circle]="history.new_status === 'rejected' || history.new_status === 'rejetée'"
                    [class.fa-clock]="history.new_status === 'pending' || history.new_status === 'en_attente'"
                    [class.fa-search]="history.new_status === 'in_progress'"
                    [class.fa-lock]="history.new_status === 'closed' || history.new_status === 'fermée'"></i>
                </div>
                <div class="timeline-content">
                  <div class="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 class="mb-1">{{ history.comment }}</h6>
                      <p class="text-muted mb-1">
                        <small>
                          <i class="fas fa-user me-1"></i>{{ history.created_by }}
                          <span class="ms-2">
                            <ng-container *ngIf="history.old_status">
                              <i class="fas fa-exchange-alt me-1"></i>
                              {{ getStatusDisplay(history.old_status).text }} →
                            </ng-container>
                            <span class="badge" [ngClass]="getStatusDisplay(history.new_status).class">
                              {{ getStatusDisplay(history.new_status).text }}
                            </span>
                          </span>
                        </small>
                      </p>
                    </div>
                    <small class="text-muted">{{ formatDate(history.created_at) }}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Fermer</button>
  </div>
</div>